import { render, staticRenderFns } from "./Cessionaria.vue?vue&type=template&id=945510ce"
import script from "./Cessionaria.vue?vue&type=script&lang=js"
export * from "./Cessionaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports